'use client'

// src/useInView.ts
import { useEffect, useRef, useState } from "react";
var useInView = (config = {}) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const element = ref.current;
    if (!element) return;
    const observer = new IntersectionObserver(([entry]) => {
      const isIntersecting = entry.isIntersecting;
      setIsVisible(isIntersecting);
      if (config.triggerOnce && isIntersecting) {
        observer.unobserve(element);
      }
    }, config);
    observer.observe(element);
    return () => {
      observer.unobserve(element);
    };
  }, []);
  return [ref, isVisible];
};

export {
  useInView
};
//# sourceMappingURL=chunk-E3SMKDYL.mjs.map